import request from '../request';

/*
  @ 生成手机验证码
  * premise
      without 无前提
      cv_account_registered 需是已注册cv用户
      cv_account_unregistered	需是未注册cv用户
      hr_account_registered 需是已注册hr用户
      hr_account_unregistered 需是未注册hr用户
  * phone_number 十一位手机号
*/
export const getPhoneCode = data => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/auth' : process.env.AUTH_ROOT) + '/v3/phone_codes',
    method: 'POST',
    data
  })
}
/*
  @ 绑定 / 解绑手机号, 及微信解绑（微信绑定走微信回调内部接口）
  * account_type 必填	cv_account/hr_account	
  * operation_type 必填	bind_phone/unbind_phone/unbind_wechat	
  * phone_number 手机号	
  * phone_code 验证码
*/
// export const patchUsersData = data => {
//   return request({
//     url: (process.env.NODE_ENV == 'development' ? '/auth' : process.env.AUTH_ROOT) + '/v1/users',
//     method: 'PATCH',
//     data
//   })
// }

/*
  @ 生成二维码（绑定用，注册登录的待开发）
  * scene_str 是	场景值（绑定微信的以bind_开头）	
  * account_type 是	cv_account/hr_account 目前只有cv端有绑定逻辑	
  * operation_type 是	bind/login 目前只用bind逻辑	
  * expire_seconds 	过期时间（秒）默认20
*/
export const getWechatsQrcode = params => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/auth' : process.env.AUTH_ROOT) + '/v3/wechat_qr_codes',
    method: 'GET',
    params
  })
}

export const getMicroCode = params => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/auth' : process.env.AUTH_ROOT) + '/v3/wechat_wxa_qrcode',
    method: 'GET',
    params
  })
}

export const getWechatScanResult = params => {
  return request({
    url: '/v3/auth/wechat_scan_users/wxa_result',
    method: 'GET',
    params
  })
}

/*
  @ 扫码结果获取（目前只绑定微信用）
  * scene_str	 是	场景值	
  * operation_type 是	bind/login 目前只有bind在用
*/
export const getWechatsQrcodeResult = params => {
  return request({
    url: '/v3/auth/wechat_scan_users/result',
    method: 'GET',
    params
  })
}


/*
  @ 获取极验参数
*/
export const geetests = params => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/auth' : process.env.AUTH_ROOT) + '/v1/geetests',
    method: 'GET',
    params
  })
}

/* 获取网申提醒二维码 */
export const getRemindCode = params => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/auth' : process.env.AUTH_ROOT) + '/v3/wechat_qr_codes',
    method: 'GET',
    params
  })
}

/* 获取用户绑定信息 */
export const get_users_bind_info = user_token => {
  return request({
    url:  `${(process.env.NODE_ENV == 'development' ? '/auth' : process.env.AUTH_ROOT)}/v3/users/${user_token}`,
    method: 'GET',
  })
}
/* 
  @ 解绑/绑定用户信息
  * operation_type    bind_phone,unbind_phone,unbind_wechat
  * phone_number
  * phone_code
*/			
export const update_users_bind_info = (data, user_token) => {
  return request({
    url:  `${(process.env.NODE_ENV == 'development' ? '/auth' : process.env.AUTH_ROOT)}/v3/users/${user_token}`,
    method: 'PUT',
    data
  })
}

/* 
  @ 根据jwt创建其它身份账户，切换身份用
  * source	pc_browser
*/			
export const create_cv_account = data => {
  return request({
    url:  `/v3/auth/cv_accounts`,
    method: 'POST',
    data
  })
}

/***
 * 绑定手机号弹窗获取当前账号的绑定信息（是否绑定手机号，当前账号中有多少份简历：简历份数大于1才显示弹窗）
 * ***/
export const getBindMessage = (cv_account_token) => {
  return request({
    url:  `/v3/auth/cv_accounts/${cv_account_token}`,
    method: 'GET'
  })
}
